/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-cardinality-visualizer-fr block)");
/* eslint-enable no-console */

(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const colors = ["#dbeafe", "#dcfce7", "#ffedd5", "#fce7f3", "#ede9fe", "#cffafe"];
        const configs = {
            "1-1": {
                labelA: "personnes",
                labelB: "passeports",
                labelC: "résultat final",
                subA: "1 personne peut avoir 1 passeport",
                subB: "1 passeport appartient à 1 personne",
                subC: "Résultat de la requête de jointure",
                explication: "<strong>Cardinalité 1:1 : une ligne de la table personnes correspond à une seule ligne de la table passeports, et inversement.</strong>",
                sqlSchema: "-- Schéma des tables\nCREATE TABLE personnes (\n  id INT PRIMARY KEY,\n  nom VARCHAR(50)\n); \n\nCREATE TABLE passeports(\n  id INT PRIMARY KEY,\n  personne_id INT UNIQUE,\n  numero VARCHAR(20),\n  FOREIGN KEY(personne_id) REFERENCES personnes(id)\n); ",
                sqlInsert: "-- Données à insérer\nINSERT INTO personnes(id, nom)\nVALUES (1, 'Alice'),(2, 'Bob'),(3, 'Claire');\n\nINSERT INTO passeports(id, personne_id, numero)\nVALUES (1, 1, 'P-1001'), (2, 2, 'P-1002'), (3, 3, 'P-1003'); ",
                sqlJoin: "-- Requête de jointure\n\nSELECT p.nom, pa.numero\nFROM personnes p\nINNER JOIN passeports pa\n  ON pa.personne_id = p.id; "
            },
            "1-N": {
                labelA: "clients",
                labelB: "commandes",
                labelC: "résultat final",
                subA: "1 client peut avoir N commandes",
                subB: "N commandes peuvent appartenir à 1 client",
                subC: "Résultat de la requête de jointure",
                explication: "<strong>Cardinalité 1:N : une ligne de la table clients peut être liée à plusieurs lignes de la table commandes.</strong> Toutes les commandes d’un même client reprennent la même couleur de fond, et le tableau résultat final montre le résultat de la jointure.",
                sqlSchema: "-- Schéma des tables\nCREATE TABLE clients(\n  id INT PRIMARY KEY,\n  nom VARCHAR(50)\n); \n\nCREATE TABLE commandes(\n  id INT PRIMARY KEY,\n  client_id INT,\n  montant DECIMAL(10, 2),\n  FOREIGN KEY(client_id) REFERENCES clients(id)\n); ",
                sqlInsert: "-- Données à insérer\nINSERT INTO clients(id, nom)\nVALUES (1, 'Alice'),(2, 'Bob'),(3, 'Claire');\n\nINSERT INTO commandes(id, client_id, montant)\nVALUES (101, 1, 25.50), (102, 1, 12.00), (103, 2, 99.99), (104, 1, 17.25), (105, 3, 48.00); ",
                sqlJoin: "-- Requête de jointure\n\nSELECT c.nom, o.id AS commande_id, o.montant\nFROM clients c\nINNER JOIN commandes o\n  ON o.client_id = c.id ORDER BY c.id, o.id; "
            },
            "N-1": {
                labelA: "commandes",
                labelB: "clients",
                labelC: "résultat final",
                subA: "N commandes peuvent appartenir à 1 client",
                subB: "1 client peut avoir N commandes",
                subC: "Résultat de la requête de jointure",
                explication: "<strong>Cardinalité N:1 : plusieurs lignes de la table commandes pointent vers une seule ligne clients.</strong> Le tableau résultat final affiche le résultat de la jointure.",
                sqlSchema: "-- Schéma des tables\nCREATE TABLE clients(\n  id INT PRIMARY KEY,\n  nom VARCHAR(50)  );\n\nCREATE TABLE commandes(\n  id INT PRIMARY KEY,\n  client_id INT,\n  montant DECIMAL(10, 2),\n  FOREIGN KEY(client_id) REFERENCES clients(id)\n); ",
                sqlInsert: "-- Données à insérer\nINSERT INTO clients(id, nom)\nVALUES (1, 'Alice'),(2, 'Bob'),(3, 'Claire');\n\nINSERT INTO commandes(id, client_id, montant)\nVALUES (101, 1, 25.50), (102, 1, 12.00), (103, 2, 99.99), (104, 1, 17.25); ",
                sqlJoin: "-- Requête de jointure\n\nSELECT o.id AS commande_id, o.montant, c.nom\nFROM commandes o\nINNER JOIN clients c\n  ON c.id = o.client_id ORDER BY o.id; "
            },
            "N-N": {
                labelA: "étudiants",
                labelB: "cours",
                labelC: "résultat final",
                subA: "Un étudiant peut suivre N cours",
                subB: "Un cours peut avoir N étudiants",
                subC: "Résultat de la requête de jointure",
                explication: "<strong>Cardinalité N:N : plusieurs lignes de la table étudiants peuvent correspondre à plusieurs lignes de la table cours.</strong> Dans ce cas, la relation est gérée par une table de liaison.",
                sqlSchema: "-- Schéma des tables\nCREATE TABLE etudiants(\n  id INT PRIMARY KEY,\n  nom VARCHAR(50)  );\n\nCREATE TABLE cours(\n  id INT PRIMARY KEY,\n  intitule VARCHAR(100) \n);\n\nCREATE TABLE inscriptions(\n  etudiant_id INT,\n  cours_id INT,\n  PRIMARY KEY(etudiant_id, cours_id),\n  FOREIGN KEY(etudiant_id) REFERENCES etudiants(id),\n  FOREIGN KEY(cours_id) REFERENCES cours(id)\n); ",
                sqlInsert: "-- Données à insérer\nINSERT INTO etudiants(id, nom)\nVALUES (1, 'Alice'),(2, 'Bob'),(3, 'Claire');\n\nINSERT INTO cours(id, intitule)\nVALUES (10, 'SQL'), (20, 'PHP'), (30, 'JS');\n\nINSERT INTO inscriptions(etudiant_id, cours_id)\nVALUES (1, 10), (1, 20), (2, 20), (2, 30), (3, 10), (3, 30); ",
                sqlJoin: "-- Requête de jointure\n\nSELECT e.nom AS etudiant, c.intitule AS cours\nFROM inscriptions i\nINNER JOIN etudiants e\n  ON e.id = i.etudiant_id\nINNER JOIN cours c\n  ON c.id = i.cours_id\nORDER BY e.id, c.id; "
            }
        };

        const dataSets = {
            "1-1": {
                left: [{ id: 1, label: "Alice", group: 0 }, { id: 2, label: "Bob", group: 1 }, { id: 3, label: "Claire", group: 2 }],
                right: [{ id: 1, label: "Passeport A", group: 0 }, { id: 2, label: "Passeport B", group: 1 }, { id: 3, label: "Passeport C", group: 2 }],
                center: [{ id: 1, label: "Alice ↔ Passeport A", group: 0 }, { id: 2, label: "Bob ↔ Passeport B", group: 1 }, { id: 3, label: "Claire ↔ Passeport C", group: 2 }]
            },
            "1-N": {
                left: [{ id: 1, label: "Alice", group: 0 }, { id: 2, label: "Bob", group: 1 }, { id: 3, label: "Claire", group: 2 }],
                right: [{ id: 101, label: "Commande 101", group: 0 }, { id: 102, label: "Commande 102", group: 0 }, { id: 103, label: "Commande 103", group: 1 }, { id: 104, label: "Commande 104", group: 0 }, { id: 105, label: "Commande 105", group: 2 }],
                center: [{ id: 101, label: "Alice ↔ Commande 101", group: 0 }, { id: 102, label: "Alice ↔ Commande 102", group: 0 }, { id: 103, label: "Bob ↔ Commande 103", group: 1 }, { id: 104, label: "Alice ↔ Commande 104", group: 0 }, { id: 105, label: "Claire ↔ Commande 105", group: 2 }]
            },
            "N-1": {
                left: [{ id: 101, label: "Commande 101", group: 0 }, { id: 102, label: "Commande 102", group: 0 }, { id: 103, label: "Commande 103", group: 1 }, { id: 104, label: "Commande 104", group: 0 }],
                right: [{ id: 1, label: "Alice", group: 0 }, { id: 2, label: "Bob", group: 1 }, { id: 3, label: "Claire", group: 2 }],
                center: [{ id: 1, label: "Commande 101 ↔ Alice", group: 0 }, { id: 2, label: "Commande 102 ↔ Alice", group: 0 }, { id: 3, label: "Commande 103 ↔ Bob", group: 1 }, { id: 4, label: "Commande 104 ↔ Alice", group: 0 }]
            },
            "N-N": {
                left: [{ id: 1, label: "Alice", group: 0 }, { id: 2, label: "Bob", group: 1 }, { id: 3, label: "Claire", group: 2 }],
                right: [{ id: 10, label: "SQL", group: 0 }, { id: 20, label: "PHP", group: 0 }, { id: 30, label: "JS", group: 1 }],
                center: [{ id: 1, label: "Alice ↔ SQL", group: 0 }, { id: 2, label: "Alice ↔ PHP", group: 0 }, { id: 3, label: "Bob ↔ PHP", group: 1 }, { id: 4, label: "Bob ↔ JS", group: 1 }, { id: 5, label: "Claire ↔ SQL", group: 2 }, { id: 6, label: "Claire ↔ JS", group: 2 }]
            }
        };

        // function renderLegend() {
        //     const grid = document.getElementById("cardGrid");
        //     grid.innerHTML = [
        //         { title: "1:1", text: "Une ligne ↔ une ligne" },
        //         { title: "1:N", text: "Une ligne → plusieurs" },
        //         { title: "N:1", text: "Plusieurs → une ligne" },
        //         { title: "N:N", text: "Plusieurs ↔ plusieurs" }
        //     ].map(function (item) {
        //         return '<div class="card-legend"><strong>' + item.title + '</strong>' + item.text + '</div>';
        //     }).join('');
        // }

        function renderSide(containerId, rows) {
            const container = document.getElementById(containerId);
            container.innerHTML = rows.map(function (row) {
                return '<div class="row-item match-' + (row.group % colors.length) + '"><div class="value">' + row.label + '</div><div class="id">id=' + row.id + '</div></div>';
            }).join('');
        }

        function update(type) {
            const cfg = configs[type];
            const data = dataSets[type];
            document.getElementById("headA").textContent = cfg.labelA;
            document.getElementById("headB").textContent = cfg.labelB;
            document.getElementById("headC").textContent = cfg.labelC;
            document.getElementById("subA").textContent = cfg.subA;
            document.getElementById("subB").textContent = cfg.subB;
            document.getElementById("subC").textContent = cfg.subC;
            document.getElementById("explication").innerHTML = cfg.explication;
            document.getElementById("sqlSchema").textContent = cfg.sqlSchema;
            document.getElementById("sqlInsert").textContent = cfg.sqlInsert;
            document.getElementById("sqlJoin").textContent = cfg.sqlJoin;
            renderSide('rowsA', data.left);
            renderSide('rowsB', data.right);
            renderSide('rowsC', data.center);
            document.querySelectorAll('.card-btn').forEach(function (b) {
                b.classList.toggle('active', b.dataset.card === type);
            });
        }

        document.querySelectorAll('.card-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                update(btn.dataset.card);
            });
        });

        // renderLegend();
        update('1-1');
    });
})();